import Col from "@visa/vds/col";
import Grid from "@visa/vds/grid";
import Row from "@visa/vds/row";
import Typography from "@visa/vds/typography";
import React, { useEffect, useState } from "react";
import { trackPromise, usePromiseTracker } from "react-promise-tracker";
import { useHistory, useLocation } from "react-router-dom";
import MCSLoading from "../../../components/MCSLoading";
import { AuthContext } from "../../../context/AuthContext";
import { GlobalAlertContext } from "../../../context/GlobalAlertContext";
import { LibraryAdminApi } from "../../../services/library.admin.service";
import { SubscriptionApi } from "../../../services/subscription.service";
import { AdminRoutes } from "../../../_constants/PageRoutes";
import PostForm from "./Components/PostForm";

function ManagePost() {
  const location = useLocation();
  const history = useHistory();
  const [error, setError] = useState(null);
  const [categoryId, setCategoryId] = useState(null);
  const [productList, setProductList] = useState(null);
  const [classificationList, setClassificationList] = useState(null);
  const [tagList, setTagList] = useState(null);
  const { promiseInProgress } = usePromiseTracker();
  const [post, setPost] = useState({
    id: 0,
    title: "",
    type: "",
    description: "",
    libraryCategoryId: location.state.categoryId,
    libraryClassificationId: "",
    libraryPostFile: { fileName: "", fileData: [] },
    libraryPostUrl: { url: "" },
    libraryPostLibraryTags: [],
    productId: "",
    notice: null,
  });

  const redirectToCategory = () => {
    history.push({
      pathname: AdminRoutes.MANAGELIBRARY_CATEGORY,
      state: {
        categoryId: categoryId,
      },
    });
  };

  const fetchData = async () => {
    let fetchDataApi = [
      LibraryAdminApi.getTagList().then((res) => {
        setTagList(res.data.tagList);
      }),
      LibraryAdminApi.getClassificationList().then((res) => {
        setClassificationList(res.data.result);
      }),
      SubscriptionApi.getProductList().then((res) => {
        setProductList(res.data.products.items);
      }),
    ];
    if (location.state.postId !== 0) {
      fetchDataApi.push(
        LibraryAdminApi.getPost(location.state.postId).then((res) => {
          setPost(res.data.result);
        })
      );
    }
    await Promise.all(fetchDataApi);
  };

  useEffect(() => {
    if (location.state == null || location.state.postId == null) {
      history.push(AdminRoutes.MANAGELIBRARY_CATEGORY);
    } else {
      setCategoryId(location.state.categoryId);
      trackPromise(fetchData());
    }
  }, []);

  if (error) {
    return <div>Error: {error.message}</div>;
  } else {
    return (
      <>
        <AuthContext.Consumer>
          {(data) => (
            <GlobalAlertContext.Consumer>
              {(alertObj) => (
                <>
                  {promiseInProgress && <MCSLoading />}
                  {!promiseInProgress && (
                    <>
                      <Grid>
                        <Row>
                          <Col>
                            <Typography tag="h1">
                              {" "}
                              {post.id === 0 ? "Add New" : "Edit"} Library
                              Object
                            </Typography>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <PostForm
                              user={data.user}
                              alertObj={alertObj}
                              post={post}
                              setPost={setPost}
                              productList={productList}
                              classificationList={classificationList}
                              tagList={tagList}
                              redirectToCategory={redirectToCategory}
                            ></PostForm>
                          </Col>
                        </Row>
                      </Grid>
                    </>
                  )}
                </>
              )}
            </GlobalAlertContext.Consumer>
          )}
        </AuthContext.Consumer>
      </>
    );
  }
}
export default ManagePost;
